import { Logger } from "@wemade-vsf/core";
const loadTotalQtyCommand = {
  execute: async (context, params) => {
    var _a, _b, _c, _d;
    Logger.debug("[Magento]: Load cart total qty");
    const apiState = context.$magento.config.state;
    if (apiState.getCartId()) {
      const { data } = await context.$magento.api.cartTotalQty(
        apiState.getCartId(),
        (_a = params == null ? void 0 : params.customQuery) != null ? _a : null,
        (_b = params == null ? void 0 : params.customHeaders) != null ? _b : null
      );
      return (_d = (_c = data == null ? void 0 : data.cart) == null ? void 0 : _c.total_quantity) != null ? _d : 0;
    }
    return 0;
  }
};
export {
  loadTotalQtyCommand
};
